/**
 * @file FormConfirmationModal.js
 * @description Confirmation popup window when performing a CRUD action
 *
 * @version 1.0.0
 * @author Carmelino Galang
 * @copyright Copyright (c) 2024, NetCyberOps LLC
 */
import React from "react";
import { Button, Modal } from "react-bootstrap";

import "./FormConfirmationModal.css";

export default function FormConfirmationModal({
  showConfirmationModal,
  handleCloseConfirmationModal,
  message,
  handleSubmit,
}) {
  return (
    <Modal
      className="confirmation-modal"
      show={showConfirmationModal}
      onHide={handleCloseConfirmationModal}
      centered
    >
      <Modal.Body>
        <h4 className="text-center">{message}</h4>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          className="confirm-btn"
          onClick={handleCloseConfirmationModal}
        >
          Cancel
        </Button>
        <Button
          className=""
          variant="secondary"
          onClick={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
